import { DASHBOARD_URL } from '../App';

export default function PricingPage() {
  return (
    <div>
      {/* Hero - extends to top, nav floats over */}
      <section className="pt-32 pb-20 sm:pt-40 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-blue-400 font-semibold mb-4">Pricing</p>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              Simple, transparent pricing
            </h1>
            <p className="text-xl text-white/70 leading-relaxed">
              We're currently in beta. Join now for early access and founding member pricing when we launch.
            </p>
          </div>
        </div>
      </section>

      {/* Beta Pricing */}
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-50 rounded-2xl border border-gray-200 p-8 md:p-12 text-center">
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
              </span>
              Beta Access
            </div>

            <h2 className="text-3xl font-bold text-slate-900 mb-4">
              Early Adopter Program
            </h2>
            <p className="text-gray-600 mb-8 max-w-lg mx-auto">
              Get full platform access during our beta period. Your feedback helps shape the product, and you'll lock in founding member pricing.
            </p>

            <ul className="text-left space-y-4 mb-10 max-w-sm mx-auto">
              {[
                'Full platform access',
                'All marketplace connectors',
                'Advanced reporting dashboards',
                'Unlimited team members',
                'Priority support',
                'Founding member pricing at launch',
              ].map((item, i) => (
                <li key={i} className="flex items-start text-gray-700">
                  <svg
                    className="w-5 h-5 text-slate-400 mr-3 mt-0.5 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>

            <a
              href={`${DASHBOARD_URL}/signup`}
              className="inline-flex items-center justify-center bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all"
            >
              Join the Beta
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gray-50 border-t border-gray-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div className="bg-white rounded-xl border border-gray-200 p-6">
              <h3 className="font-semibold text-slate-900 mb-2">
                Is the beta really free?
              </h3>
              <p className="text-gray-600 text-sm">
                Yes. During the beta period, you get full access to all features at no cost. We're focused on gathering feedback and building the best possible product.
              </p>
            </div>

            <div className="bg-white rounded-xl border border-gray-200 p-6">
              <h3 className="font-semibold text-slate-900 mb-2">
                What happens when you launch paid plans?
              </h3>
              <p className="text-gray-600 text-sm">
                Beta users will receive advance notice and lock in founding member pricing—a permanent discount on whatever plan you choose.
              </p>
            </div>

            <div className="bg-white rounded-xl border border-gray-200 p-6">
              <h3 className="font-semibold text-slate-900 mb-2">
                Do I need to give you my Odoo credentials?
              </h3>
              <p className="text-gray-600 text-sm">
                Yes, but they're stored securely with encryption. We recommend creating a dedicated API user in Odoo with appropriate permissions for NexusERP.
              </p>
            </div>

            <div className="bg-white rounded-xl border border-gray-200 p-6">
              <h3 className="font-semibold text-slate-900 mb-2">
                Which Odoo versions are supported?
              </h3>
              <p className="text-gray-600 text-sm">
                We support Odoo versions 14 through 18, both Enterprise and Community editions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
